const organisations = {
	title: "Organisations",
	title_s: "Organisation",
	new_organisation: "New Organisation",
	edit_organisation: "Edit Organisation: {name}",
	view_organisation: "View Organisation: {name}",
	list_title: "List of Organisations",
	list_subtitle: "Manage organisations",
	create_title: "Create New Organisation",
	update_title: "Update Organisation",
	details_title: "Organisation Details",
	visiting_address_title: "Visiting Address",
	invoice_address_title: "Invoice Address",
	invoice_title: "Invoice Details",
	id: "ID",
	name: "Name",
	tenant_company: "Tenant Company",
	email: "Email",
	vat: "VAT",
	phone: "Phone",
	owner: "System Owner",
	po_number: "PO",
	invoice_ref: "Customer Ref.",
	email_invoice: "Invoice Email",
	same_as_visiting: "Same as Visiting Address",
	customergroups: "Customer Groups",
	member_organisation: "Is Member Organisation",
	members_of: "Member of",
	certification_agencies: "Certified By",
	certification_authority: "Certification Authority",
	certification_authority_short: "Cert. Auth.",
	sms_service: "SMS Service Status",
	upload_org_logo: "Upload Logo",
	upload_org_signature: "Upload signature",
	signature: "Signature",
	visiting_street: "Street",
	visiting_city: "City",
	visiting_state: "State",
	visiting_zip: "Zip",
	visiting_country: "Country",
	invoice_street: "Street",
	invoice_city: "City",
	invoice_state: "State",
	invoice_zip: "Zip",
	invoice_country: "Country",
	show_logo: "Show logo",
	upload_logo: "Upload a logo image",
	update_logo: "Update the logo image",
	uploaded_logo: "The logo was uploaded!",
	updated_logo: "The logo was updated!",
	remove_logo: "Remove logo!",
	upload_image: "Upload/Update Logo",
	select_image: "Select logo to upload",
	upload_signature_digital: "Digital Signature",
	upload_signature: "Upload/Update Signature",
	select_signature: "Select signature to upload",
	sms_usage: "SMS Usage",
	sms_select_year: "Select Year",
	org_does_not_exist: "No organisation found",
	vat_does_not_exist: "VAT does not exist",
	course_id_increment_start: "Course id start number",
	tenant_vat_number: "Tenant VAT number",
	notif_email_from: "Notification email sender",
	notif_sms_from: "Notification sender number",
	invalid_email: "Invalid email",
	email_same: "Email is the same",
	sms_same: "SMS is the same",
	code_send: "A code is sent to this recepient:",
	cannot_generate_code: "Unable to generate code. Please contact administrator.",
	incorrect_code: "Incorrect or expired code.",
	swagger_token: "Swagger Token",
	open_swagger: "Open Swagger",
	notif_email_not_verified: "Email not verified. Check your inbox",
	notif_email_verified: "Verified",
	resend_verify: "Resend/Verify",
	certification_id: "Certification / Approval ID",
};
export default organisations;